import React from "react";
import { Row } from "react-bootstrap";
import { connect } from "react-redux";
import { ActivityLogs } from "../../activityLogs";
import { GetActivityLogs } from "../action";
import { DataType } from "constant";

import moment from "moment";

import { FeatureKeysPath } from "routes/paths";

const FeatureKeysActivityLogFilters = Object.freeze([
  {
    key: "unitFamilyName",
    value: "Family",
    isDefault: true,
    dataType: DataType.String,
  },
  { key: "UserId", value: "User", dataType: DataType.String },
]);

const FeatureKeysActivityLogs = ({ GetActivityLogs, history }) => {
  return (
    <div className="container-fluid">
      <h1>Feature Keys</h1>
      <Row>
        <ActivityLogs
          hasActivityFilter
          onFetchActivityLogs={GetActivityLogs}
          onBackMainPage={() => history.push(FeatureKeysPath)}
          activityLogFilters={FeatureKeysActivityLogFilters}
          backButtonLabel={"View Feature Keys"}
          extraColumns={[
            {
              dataField: "unitFamilyName",
              text: "Family",
              sort: true,
              style: { wordWrap: "break-word" },
              headerStyle: { wordWrap: "break-word" },
              title: (cell) => cell,
            },
          ]}
          extraSortColumns={{
            unitFamilyName: 1,
          }}
          detailsModalHeader={[
            {
              label: "Family",
              value: "unitFamilyName",
            },
            {
              label: "Activity",
              value: "activity",
            },
            {
              label: "User",
              value: "user",
            },
            {
              label: "Date",
              value: "date",
              formatter: (data) => moment(data).format("LLL"),
            },
          ]}
        />
      </Row>
    </div>
  );
};

export default connect(() => {}, { GetActivityLogs })(FeatureKeysActivityLogs);
